// extracted by mini-css-extract-plugin
export default {"createCategory":"CategoryCreate_createCategory__OE4yG","createCatgoryBtn":"CategoryCreate_createCatgoryBtn__uSurF","form":"CategoryCreate_form__MG+hr"};